import { observer } from 'mobx-react'
import StaffingViewModel from './StaffingViewModel'
import React from 'react'
import { useScrollOffsetSpring } from '../../../../hooks/spring-hooks'
import styles from './Staffing.sass'
import StaffingHeader from '../StaffingHeader'
import { useActivation } from '../../../../hooks/mobx-hooks'
import { useDocumentTitle } from '../../../../hooks/document-title'
import {
  SideSheetHostView,
  SideSheetMain,
  SideSheet,
} from '../../../../components/SideSheet'
import {
  TableHost,
  TableScrollingContainer,
} from '../../../../components/Table'
import { TableSearchbar } from '../../../../payouts/components/TableSearchbar'
import { ContentLayout } from '../../../../components/ContentLayout'
import WorkspacePostingStatusFilter from '../WorkspacePostingStatusFilter'
import StaffingTable from '../StaffingTable'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'
import WorkspacePostingCount from '../WorkspacePostingCount'
import StaffingDetailsPanel from '../StaffingDetailsPanel'
import CreateWorkspacePostingDialog from '../CreateWorkspacePostingDialog'
import UpdateWorkspacePostingDialog from '../UpdateWorkspacePostingDialog'
import ApplicantManagementPanel from '../ApplicantManagementPanel'

interface StaffingProps {
  vm: StaffingViewModel
}

export default observer(function Staffing({ vm }: StaffingProps) {
  useDocumentTitle('Staffing Manager')
  useActivation(vm)

  return vm.activate.match({
    pending: () => <ContentLoading />,
    rejected: (err) => <ContentError error={err} />,
    resolved: () => <StaffingContent vm={vm} />,
  })
})

const StaffingContent = observer(function ({ vm }: StaffingProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)

  return (
    <div className={styles.root}>
      <SideSheetHostView sheetVisible={vm.staffingDetailsVM?.showing}>
        <SideSheetMain>
          <div className={styles.mainContainer} ref={scrollRef}>
            <StaffingHeader scrollOffset={scrollOffset} vm={vm} />
            <WorkspacePostingStatusFilter filter={vm.searcher.statusFilter} />
            <WorkspacePostingCount vm={vm.searcher} />
            <ContentLayout>
              <TableHost>
                <TableSearchbar
                  searchText={vm.searcher.searchText}
                  onSearchTextChange={(value) =>
                    vm.searcher.setSearchText(value)
                  }
                />
                <TableScrollingContainer>
                  <StaffingTable vm={vm} />
                </TableScrollingContainer>
              </TableHost>
            </ContentLayout>
          </div>
        </SideSheetMain>
        <SideSheet>
          <StaffingDetailsPanel vm={vm.staffingDetailsVM} />
        </SideSheet>
      </SideSheetHostView>
      <CreateWorkspacePostingDialog vm={vm.createWorkspacePostingVM} />
      <UpdateWorkspacePostingDialog vm={vm.updateWorkspacePostingVM} />
      <ApplicantManagementPanel
        vm={vm.staffingDetailsVM.applicantManagementPanelVM}
      />
    </div>
  )
})
